import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createSelector } from 'reselect';

import { ROUTES } from 'constants/routes';
import { actionCreators as tipActions } from 'redux/tipHandlers';
import Images from 'config/assets';
import { gaTrackPageView } from 'services/AnalyticsService';

import EnergyAdvisor from './layout';

const buttonImages = [
  { image: Images.energyAdvisorWheelButton04, imageHovered: Images.energyAdvisorWheelButton04Hover },
  { image: Images.energyAdvisorWheelButton02, imageHovered: Images.energyAdvisorWheelButton02Hover },
  { image: Images.energyAdvisorWheelButton01, imageHovered: Images.energyAdvisorWheelButton01Hover },
  { image: Images.energyAdvisorWheelButton05, imageHovered: Images.energyAdvisorWheelButton05Hover },
  { image: Images.energyAdvisorWheelButton03, imageHovered: Images.energyAdvisorWheelButton03Hover },
  { image: Images.energyAdvisorWheelButton06, imageHovered: Images.energyAdvisorWheelButton06Hover }
];

class EnergyAdvisorContainer extends Component {
  componentDidMount() {
    this.props.dispatch(tipActions.getPlaces());
    gaTrackPageView(ROUTES.ENERGY_ADVISOR);
  }

  handleClick = item =>
    this.props.dispatch(
      push({
        pathname: ROUTES.ENERGY_ADVISOR_TIPS,
        params: item.tipParams
      })
    );

  render() {
    return <EnergyAdvisor buttons={this.props.buttons} onClick={this.handleClick} />;
  }
}

const buttonsSelector = createSelector(
  store => store.tip.places,
  places =>
    places.map((place, index) => ({
      ...buttonImages[index],
      id: index,
      title: place.name,
      icon: place.icon_url,
      tipParams: {
        placeId: place.id,
        placeText: place.name,
        icon: place.icon_url
      }
    }))
);

const mapStateToProps = store => ({
  buttons: buttonsSelector(store)
});

EnergyAdvisorContainer.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      imageHovered: PropTypes.string.isRequired
    }).isRequired
  ).isRequired
};

export default connect(mapStateToProps)(EnergyAdvisorContainer);
